<script lang="ts">
	import { AppMenu, BaseButton, IconButton } from '@shared/svelte';
	import { getProjectActionsModel } from './project-actions-model';
	import t from '$i18n';
	const viewModel = getProjectActionsModel();
	const { moreOptions } = viewModel;
</script>

<div class="flex gap-2">
	<!-- <BaseButton
		label="Translate"
		minifyOnTablet
		color="secondary"
		icon="upload"
		on:click={() => viewModel.translate()} /> -->

	<BaseButton
		label={$t.upload()}
		minifyOnTablet
		color="secondary"
		icon="upload"
		on:click={() => viewModel.upload()} />

	<BaseButton
		label={$t.download()}
		minifyOnTablet
		color="secondary"
		icon="download"
		on:click={() => viewModel.download()} />

	<AppMenu options={$moreOptions}>
		<IconButton
			icon="dots-three"
			size={10}
			hint={$t.more_video_options_hint()} />
	</AppMenu>
</div>
